import * as e from "react";
import { useSyncExternalStore as t } from './useSyncExternalStoreShimClient.js';
import { useSyncExternalStore as o } from './useSyncExternalStoreShimServer.js';
var r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined",
    s = !r,
    c = s ? o : t,
    a = "useSyncExternalStore" in e ? function (n) {
  return n.useSyncExternalStore;
}(e) : c;
export { a as useSyncExternalStore };